import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSoftphone } from '../contexts/SoftphoneContext';
import { useSessionUser } from '../SessionContext';
import { buildAgentStatePayload, sendAgentStateLog } from '../lib/agentStateLog';
import { unregisterAgentPresence } from '../lib/agentPresence';
import api from '../services/api';

export default function Logout() {
  const navigate = useNavigate();
  const { disconnect, hangup } = useSoftphone();
  const { clearUser } = useSessionUser();

  useEffect(() => {
    const withTimeout = (promise, ms) =>
      Promise.race([
        Promise.resolve().then(() => promise),
        new Promise((resolve) => setTimeout(resolve, ms))
      ]);

    const clearAndRedirect = () => {
      try {
        const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
        const callerListUserId =
          storedUser.UserID ||
          storedUser.userId ||
          storedUser.ID ||
          storedUser.id ||
          storedUser.FullName ||
          storedUser.UserName ||
          storedUser.LoginName ||
          storedUser.username ||
          '';
        if (callerListUserId !== '') {
          localStorage.removeItem(`callerListState:${callerListUserId}`);
        }
      } catch {
        // Continue logout even if persisted user data is invalid.
      }
      clearUser();
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('extension');
      sessionStorage.clear();
      console.log('✅ Session cleared');
      navigate('/login', { replace: true });
    };

    // Hard cap: logout must complete in 2s no matter what
    const hardTimeout = setTimeout(clearAndRedirect, 2000);

    const performLogout = async () => {
      try {
        try { hangup(); } catch { /* no active call */ }

        // Each network call capped at 1s — fire-and-forget on timeout
        await withTimeout(Promise.all([
          api.post('/session/logout').catch(() => {}),
          unregisterAgentPresence().catch(() => {})
        ]), 1000);
        await withTimeout(disconnect().catch(() => {}), 1000);

        try {
          const payload = buildAgentStatePayload({
            status: 'logout',
            reason: 'logout',
            inQueue: '0'
          });
          if (payload) {
            await withTimeout(sendAgentStateLog(payload).catch(() => {}), 1000);
          }
        } catch (err) {
          console.warn('Agent state logout log failed:', err?.message || err);
        }
      } finally {
        clearTimeout(hardTimeout);
        clearAndRedirect();
      }
    };

    performLogout();
  }, [navigate, disconnect, hangup, clearUser]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '18px',
      color: '#666'
    }}>
      Logging out and clearing session...
    </div>
  );
}
